<template>
       <footer class="footer scrollbaroff">
        <div class="swiper-scrollbar"></div>
        <div class="container-fluid contenedor_footer pt-2">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center mt-1">
                    <nav aria-label="Page">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="page-link texto_paginador" href="#" aria-label="Previous"> <span class="swiper-button-prev swiper-button-white icon-atras text-white boton_anterior"></span> </a>
                            </li>
                            <li class="page-item ml-3">
                                <a class="page-link texto_paginador" href="#"> <span id="text_pagination" class="text-center font-weight-normal text-white"> </span> </a>
                            </li>
                            <li class="page-item">
                                <a class="page-link texto_paginador" href="#" aria-label="Next"> <span class="swiper-button-next swiper-button-white icon-siguiente text-white boton_siguiente"></span> </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>